import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Process, Partners, Banner, FAQs, DownloadApp } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <WhyUs />
        <Process />
        <Banner />
        <FAQs />
        <Testimonials />
        <Team />
        <DownloadApp />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;